(async () => {

  if (!customElements.get('hero-slider-swiper')) {

    const { default: Swiper, Navigation, Pagination, Scrollbar, Autoplay } = await import("swiper");

    Swiper.use([
      Navigation,
      Pagination,
      Scrollbar,
      Autoplay
    ]);

    class HeroSwiper extends HTMLElement {
      constructor() {
        super();

        this.swiperElement = this.querySelector('[data-swiper-hero-slider]');
        this.swiperOptions = {
          observer: true,
          threshold: 10
        };

        // Check if we have extra options on the HTML
        if (this && this.dataset && this.dataset.options) {
          const jsonOptions = JSON.parse(this.dataset.options);

          if (jsonOptions) {
            this.swiperOptions = {
              ...this.swiperOptions,
              ...jsonOptions
            }
          }
        }

        // re-init slider when Theme Editor is active
        if (Shopify.designMode && this.swiperElement) {

          // Update the swiper
          window.addEventListener('shopify:section:load', (e) => {
            if (this.swiperOptions.sectionId && this.swiperOptions.sectionId === e.detail.sectionId) {
              this.updateSwipers();
            }
          });

          // Slide to the slide when a specific block is selected
          window.addEventListener('shopify:block:select', (event) => {
            this.handleSectionEvents(event);
          });
        }

        this.init();
      }

      init() {
        this.swiperElement = new Swiper(this.swiperElement, this.swiperOptions);
      }

      updateSwipers() {
        // Update the swiper
        this.swiperElement.update();
        if(this.swiperOptions.navigation) {
          this.swiperElement.navigation.init();
          this.swiperElement.navigation.update();
        }
        if(this.swiperOptions.pagination) {
          this.swiperElement.pagination.init();
          this.swiperElement.pagination.render();
          this.swiperElement.pagination.update();
        }
      }

      /**
       * Handles the theme editor block change/edit event
       * @param {Object} event
       */
      handleSectionEvents(event) {
        // Slide to slide based on the data attribute from the target and add 1 to get the slide index
        this.swiperElement.slideTo(parseInt(event.target.dataset.swiperSlideIndex) + 1);
      }
    }

    window.HeroSwiper = HeroSwiper;

    customElements.define('hero-slider-swiper', HeroSwiper);

  }

})();
